var _a, _b;
import cxs from 'cxs/component';
import Theme, { mediaQueries } from 'Theme';
import { Button } from 'elements';
export var AddButton = cxs(Button)({
    width: '100%',
    height: '100%',
    /*position: 'fixed',*/
    /*bottom: Theme.size.bar,*/
    backgroundColor: Theme.color.background,
    borderTop: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline),
    /*[mediaQueries.desktop]: {*/
    position: 'absolute',
    bottom: 0,
    // borderBottom: `${Theme.size.hairline} solid ${Theme.color.hairline}`
    /*}*/
});
export var ButtonsBar = cxs('div')((_a = {
        height: Theme.size.bottomButtons,
        display: 'flex',
        width: '100%',
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: Theme.color.background,
        zIndex: 1,
        borderTop: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline),
        '> button': {
            flex: 'auto',
            borderRight: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline),
            ':last-child': {
                borderWidth: 0
            }
        }
    },
    // borderBottom: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
    _a[mediaQueries.desktop] = {
    // marginTop: Theme.size.space[2],
    },
    _a));
export var StyledButton = cxs(Button)((_b = {
        flex: 2
    },
    _b[mediaQueries.desktop] = {
    // padding: Theme.size.space[2]
    },
    _b));



//////////////////
// WEBPACK FOOTER
// ./src/Styles.ts
// module id = 34
// module chunks = 0